<template>
  <div
    data-aos-easing="ease"
    data-aos-duration="400"
    data-aos-delay="0"
    class="container h-100"
  >
    <div
      class="
        row
        d-flex
        flex-column
        min-vh-100
        justify-content-center
        align-items-center
      "
    >
      <div class="col-auto">
        <div
          data-aos="fade-right"
          class="containlogin boxcolor aos-init aos-animate"
        >
          <div class="logologin">
            <img
              class="imganimationlogin mt-2"
              src="./../assets/image/logpj.png"
            />
          </div>
          <div class="containinlogin">
            <div style="text-align: center; margin-top: 10px">
              <h4 class="textlogin">เข้าสู่ระบบ</h4>
            </div>
            <div style="margin-top: 15px">
              <div class="iconlogin">
                <i class="fal fas fa-user" style="font-size: 17px"></i>
              </div>
              <input
                type="text"
                class="form-control loginform01"
                v-model="username"
                @keyup.enter="Login()"
                aria-describedby="username"
                placeholder="ชื่อผู้ใช้ / เบอร์โทรศัพท์"
              />
            </div>
            <div style="margin-top: 15px">
              <div class="iconlogin">
                <i class="fal fas fa-lock" style="font-size: 17px"></i>
              </div>
              <input
                type="password"
                class="form-control loginform01"
                v-model="password"
                @keyup.enter="Login()"
                aria-describedby="password"
                placeholder="รหัสผ่าน"
              />
            </div>
          </div>
          <div style="text-align: center; margin-top: 20px; padding: 0 30px">
            <button @click="Login()" @keyup.enter="Login()" class="btn mcolor colorbtn01 mb-2">
              เข้าสู่ระบบ
            </button>
            <a
              href="https://lin.ee/6a9H25M"
              target="_blank"
              class="btn linecolor colorbtn01"
            >
              <i class="fa-brands fa-line"></i> ติดต่อไลน์
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "./../services/index.js";
import config from "./../config/index.js";
import {mapMutations} from 'vuex'

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
    };
  },
  async mounted(){
    if(this.$route.query.token){
      this.setAccessToken(this.$route.query.token);
      this.$router.push("/home");
    }
  },
  methods: {
    ...mapMutations(["setAccessToken"]),
    async Login() {
      if (this.username == "" || this.password == "")
        return this.$swal.fire(
          "เกิดข้อผิดพลาด!",
          "กรุณากรอกข้อมูลให้ครบ",
          "error"
        );
      api
        .post("/login", {
          username: this.CryptoJS.AES.encrypt(
            this.username,
            config.Crypto_Secret
          ).toString(),
          password: this.CryptoJS.AES.encrypt(
            this.password,
            config.Crypto_Secret
          ).toString(),
        })
        .then(async (v) => {
          if (v.status.code == 200) {
            if (v.data.token) {
              this.setAccessToken(v.data.token);
              this.$router.push("/home");
            } else {
              this.$swal.fire({
                icon: "error",
                title: v.status.message,
                timerProgressBar: true,
                allowOutsideClick: false,
              });
            }
          } else {
            this.$swal.fire({
              icon: "error",
              title: v.status.message,
              timerProgressBar: true,
              allowOutsideClick: false,
            });
          }
        })
        .catch(async (e) => {
          this.$swal.fire({
            icon: "error",
            title: e.status.message,
            timerProgressBar: true,
            allowOutsideClick: false,
          });
        });
    },
  },
};
</script>

<style>
</style>